import { Container } from "../../../../src/blocks";
import { Recents } from "../../../../src/components/recents";
import Intro from "../../../../src/pages/intro";
import Projects from "../../../../src/pages/projects";
import * as React from 'react';
export default {
  Container,
  Recents,
  Intro,
  Projects,
  React
};